let minMaxDatesErrorMsg =
  "Sorry!  Select another product with same delivery dates to continue. Thanks.";

// Each product only delivers inside its own date window, so a rejected date
// should name the real limit (e.g. "November 2, 2026") rather than call a
// future date "in the past". Also used by the date field in upsell-popup.js.
function formatDeliveryDate(dateStr) {
  const parts = dateStr.split("-");
  return new Date(parts[0], parts[1] - 1, parts[2]).toLocaleDateString(
    "en-US",
    { month: "long", day: "numeric", year: "numeric" }
  );
}

function earliestDeliveryDateMsg(minDateStr) {
  return `The earliest delivery date for the items in your cart is ${formatDeliveryDate(minDateStr)}. Please choose that date or later.`;
}

function latestDeliveryDateMsg(maxDateStr) {
  return `The latest delivery date for the items in your cart is ${formatDeliveryDate(maxDateStr)}. Please choose that date or earlier.`;
}
window.addEventListener("pageshow", function (event) {
  history.pushState(null, document.title, location.href); // Disable browser forward button
  // Early exit if form doesn't exist (gift card only cart)
  if (!document.getElementById("main-cart-attribute")) {
    return;
  }
  if (
    event.persisted ||
    (window.performance && window.performance.navigation.type === 2)
  ) {
    // The page is being restored from the cache (back button pressed)
    document.getElementById("Cart-note").value = "";
    document.getElementById("email").value = "";
    document.getElementById("who-is-the-gift-for-first-name").value = "";
    document.getElementById("who-is-the-gift-for-last-name").value = "";
    document.getElementById("primary-name-reservation").value = "";
    document.getElementById("gift-message").value = "";
    document.getElementById("delivery_date").value = "";
    document.getElementById("recipients-contact-number").value = "";
    document.querySelector(
      'input[name="available_dilevry_locations"]'
    ).checked = true;

    const containers = document.querySelectorAll('.upsell__variant__picker--fieldset');
    containers.forEach(container => {
      // Select the first radio button within each container
      const firstRadioButton = container.querySelector('input[type="radio"]');
      if (firstRadioButton) {
        // Set the first radio button as checked
        firstRadioButton.checked = true;
      }
    });

    if (localStorage.getItem("__ui")) {
      localStorage.removeItem("__ui"); // Resolve cart notes issue
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  history.pushState(null, document.title, location.href); // Disable browser forward button
  // Early exit if form doesn't exist (gift card only cart)
  if (!document.getElementById("main-cart-attribute")) {
    return;
  }
  // Validation for checkoutButton
  // Get required data
  const checkoutButton = document.getElementById("checkout");
  const Email = document.getElementById("email");
  const Name = document.getElementById("who-is-the-gift-for-first-name");
  const Lname = document.getElementById("who-is-the-gift-for-last-name");
  const Pname = document.getElementById("primary-name-reservation");
  const Message = document.getElementById("gift-message");
  const DeliveryDate = document.getElementById("delivery_date");
  const errorContainer = document.getElementById("error-container");
  const recipientsContactNumber = document.getElementById(
    "recipients-contact-number"
  );

  // Set values to '' when page load
  document.querySelector(
    'input[name="available_dilevry_locations"]'
  ).checked = true;
  document.getElementById("Cart-note").value = "";
  document.getElementById("email").value = "";
  document.getElementById("who-is-the-gift-for-first-name").value = "";
  document.getElementById("who-is-the-gift-for-last-name").value = "";
  document.getElementById("primary-name-reservation").value = "";
  document.getElementById("gift-message").value = "";
  document.getElementById("delivery_date").value = "";
  document.getElementById("recipients-contact-number").value = "";

  const containers = document.querySelectorAll('.upsell__variant__picker--fieldset');
  containers.forEach(container => {
    // Select the first radio button within each container
    const firstRadioButton = container.querySelector('input[type="radio"]');

    if (firstRadioButton) {
      // Set the first radio button as checked
      firstRadioButton.checked = true;
    }
  });

  // Resolve cart notes issue
  if (localStorage.getItem("__ui")) {
    localStorage.removeItem("__ui");
  }

  // Enable checkout button when page loads and remove pointer none from form
  checkoutButton.disabled = false;
  document.getElementById("main-cart-attribute").style.pointerEvents = "all";

  // Add search on select
  // new SlimSelect({
  //   select: "#disney_resorts-locations",
  // });
  // new SlimSelect({
  //   select: "#local_hotelss-locations",
  // });
  // new SlimSelect({
  //   select: "#other_locations-locations",
  // });

  const disneyResorts = new TomSelect('#disney_resorts-locations', {
    create: false,
    sortField: {
      field: 'text',
      direction: 'asc'
    }
  });
  const localHotels = new TomSelect('#local_hotelss-locations', {
    create: false,
    sortField: {
      field: 'text',
      direction: 'asc'
    }
  });
  const otherLocations = new TomSelect('#other_locations-locations', {
    create: false,
    sortField: {
      field: 'text',
      direction: 'asc'
    }
  });

  // Check if current time is before or after 12 PM in EST
  function isBeforeCutOffTime(currrentTimeEST) {
    return Number(currrentTimeEST.split(" ")[1].split(":")[0]) < custoffTime;
  }

  let datePicker = document.getElementById("delivery_date");
  let clonedDatePicker = document.getElementById("delivery_date_clone");
  let deliveryDateErrMsg = document.querySelector(".delivery_date_err_msg");
  let arrivalDatePicker = document.getElementById("arrival-date");
  let departureDatePicker = document.getElementById("departure-date");
  let arrivalDateErrMsg = document.querySelector(".arrival_date_err_msg");
  let departureDateErrMsg = document.querySelector(".departure_date_err_msg");
  const pastDateErrorMsg =
    "You cannot select a date in the past. Please choose a valid date.";
  let lastIOSDateAlertKey = null;

  function isIOSDevice() {
    return (
      /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
    );
  }

  function notifyInvalidDateSelection(input, message, attemptedDate) {
    if (!isIOSDevice() || !attemptedDate) return;

    const alertKey = (input && input.id ? input.id : "date") + "|" + attemptedDate;
    if (lastIOSDateAlertKey === alertKey) return;

    lastIOSDateAlertKey = alertKey;
    setTimeout(function () {
      lastIOSDateAlertKey = null;
    }, 2500);

    window.alert(message);
  }

  function normalizeDateStr(dateStr) {
    if (!dateStr) return "";
    const parts = dateStr.split("-");
    const year = parts[0];
    const month = String(Number(parts[1])).padStart(2, "0");
    const day = String(Number(parts[2])).padStart(2, "0");
    return year + "-" + month + "-" + day;
  }

  function getTodayDateStr() {
    if (typeof currrentTimeEST === "undefined") return "";
    return normalizeDateStr(currrentTimeEST.split(" ")[0]);
  }

  function getMinDateStr() {
    const min =
      window.minDeliveryDate || (datePicker && datePicker.min) || "";
    return normalizeDateStr(min);
  }

  function getMaxDateStr() {
    const max =
      window.maxDeliveryDate || (datePicker && datePicker.max) || "";
    return normalizeDateStr(max);
  }

  function isDateBefore(dateStr, compareStr) {
    if (!dateStr || !compareStr) return false;
    return normalizeDateStr(dateStr) < normalizeDateStr(compareStr);
  }

  function showDateError(msg) {
    if (deliveryDateErrMsg) deliveryDateErrMsg.textContent = msg;
  }

  function clearDateError() {
    if (deliveryDateErrMsg) deliveryDateErrMsg.textContent = "";
  }

  function showOptionalDateError(element, msg) {
    if (element) element.textContent = msg;
  }

  function clearOptionalDateError(element) {
    if (element) element.textContent = "";
  }

  function rejectPastOrMinDate(input, showErrorFn, clearErrorFn) {
    if (!input) return true;

    const selectedDate = input.value;
    if (!selectedDate) {
      clearErrorFn();
      return true;
    }

    const today = getTodayDateStr();
    const minDateStr = getMinDateStr();

    if (isDateBefore(selectedDate, today)) {
      showErrorFn(pastDateErrorMsg);
      notifyInvalidDateSelection(input, pastDateErrorMsg, selectedDate);
      input.value = "";
      return false;
    }

    if (minDateStr && isDateBefore(selectedDate, minDateStr)) {
      const earliestMsg = earliestDeliveryDateMsg(minDateStr);
      showErrorFn(earliestMsg);
      notifyInvalidDateSelection(input, earliestMsg, selectedDate);
      input.value = "";
      return false;
    }

    clearErrorFn();
    return true;
  }

  function applyMinMaxToDateInput(input, minDate, maxDate) {
    if (!input) return;
    input.min = minDate;
    input.max = maxDate;
    input.setAttribute("min", minDate);
    input.setAttribute("max", maxDate);
  }

  // Set min/max before listeners so iOS reads constraints when the picker opens
  let currentESTDate = currrentTimeEST.split(" ")[0].split("-");
  let minDate = window.minDeliveryDate;
  let maxYear = "";
  let maxMonth = "";

  if (Number(currentESTDate[1]) + 12 > 12) {
    maxYear = Number(currentESTDate[0]) + 1;
    maxMonth = ("0" + ((Number(currentESTDate[1]) + 12) % 12)).slice(-2);
  } else {
    maxYear = Number(currentESTDate[0]);
    maxMonth = ("0" + (Number(currentESTDate[1]) + 12)).slice(-2);
  }
  let maxLimit = window.maxDeliveryDate;

  if (datePicker && minDate && maxLimit) {
    applyMinMaxToDateInput(datePicker, minDate, maxLimit);
    applyMinMaxToDateInput(arrivalDatePicker, minDate, maxLimit);
    applyMinMaxToDateInput(departureDatePicker, minDate, maxLimit);

    let max_delivery_date = maxLimit.split("-");
    let min_delivery_date = minDate.split("-");
    if (
      Number(min_delivery_date[0]) > Number(max_delivery_date[0]) ||
      (Number(min_delivery_date[0]) == Number(max_delivery_date[0]) &&
        Number(min_delivery_date[1]) > Number(max_delivery_date[1])) ||
      (Number(min_delivery_date[0]) == Number(max_delivery_date[0]) &&
        Number(min_delivery_date[1]) == Number(max_delivery_date[1]) &&
        Number(min_delivery_date[2]) > Number(max_delivery_date[2]))
    ) {
      if (deliveryDateErrMsg) {
        deliveryDateErrMsg.textContent = minMaxDatesErrorMsg;
      }
    }
  }

  function handleDateSelection() {
    if (!datePicker) return;

    let selectedDate = datePicker.value;
    if (!selectedDate) return;

    if (!rejectPastOrMinDate(datePicker, showDateError, clearDateError)) {
      return;
    }

    const maxDateStr = getMaxDateStr();
    const disabledDateMsg =
      "This date is disabled. Please choose another date.";

    if (
      typeof disabledDates !== "undefined" &&
      disabledDates.includes(selectedDate)
    ) {
      showDateError(disabledDateMsg);
      notifyInvalidDateSelection(datePicker, disabledDateMsg, selectedDate);
      datePicker.value = "";
      return;
    }

    if (maxDateStr && isDateBefore(maxDateStr, selectedDate)) {
      const latestMsg = latestDeliveryDateMsg(maxDateStr);
      showDateError(latestMsg);
      notifyInvalidDateSelection(datePicker, latestMsg, selectedDate);
      datePicker.value = "";
      return;
    }

    let datePickerMaxValue = maxDateStr.split("-");
    let datePickerMinValue = getMinDateStr().split("-");
    if (Number(datePickerMaxValue[0]) < Number(datePickerMinValue[0])) {
      showDateError(minMaxDatesErrorMsg);
      notifyInvalidDateSelection(datePicker, minMaxDatesErrorMsg, selectedDate);
      datePicker.value = "";
    } else if (
      Number(datePickerMaxValue[0]) == Number(datePickerMinValue[0]) &&
      Number(datePickerMaxValue[1]) < Number(datePickerMinValue[1])
    ) {
      showDateError(minMaxDatesErrorMsg);
      notifyInvalidDateSelection(datePicker, minMaxDatesErrorMsg, selectedDate);
      datePicker.value = "";
    } else if (
      Number(datePickerMaxValue[0]) == Number(datePickerMinValue[0]) &&
      Number(datePickerMaxValue[1]) == Number(datePickerMinValue[1]) &&
      Number(datePickerMaxValue[2]) < Number(datePickerMinValue[2])
    ) {
      showDateError(minMaxDatesErrorMsg);
      notifyInvalidDateSelection(datePicker, minMaxDatesErrorMsg, selectedDate);
      datePicker.value = "";
    } else {
      if (clonedDatePicker) {
        clonedDatePicker.min = minDate;
        clonedDatePicker.max = maxLimit;
        clonedDatePicker.value = datePicker.value;
      }
    }
  }

  function validateArrivalDate() {
    rejectPastOrMinDate(
      arrivalDatePicker,
      (msg) => showOptionalDateError(arrivalDateErrMsg, msg),
      () => clearOptionalDateError(arrivalDateErrMsg)
    );
  }

  function validateDepartureDate() {
    rejectPastOrMinDate(
      departureDatePicker,
      (msg) => showOptionalDateError(departureDateErrMsg, msg),
      () => clearOptionalDateError(departureDateErrMsg)
    );
  }

  // iOS Safari ignores min/max and may not fire change until blur
  function attachIOSDateValidation(input, validateFn) {
    if (!input) return;

    let lastValue = input.value;
    let pollId = null;

    const runValidation = function () {
      validateFn();
      lastValue = input.value;
    };

    input.addEventListener("input", runValidation);
    input.addEventListener("change", runValidation);
    input.addEventListener("focusout", runValidation);

    input.addEventListener("focus", function () {
      lastValue = input.value;
      if (pollId) clearInterval(pollId);
      pollId = setInterval(function () {
        if (document.activeElement !== input) {
          clearInterval(pollId);
          pollId = null;
          runValidation();
          return;
        }
        if (input.value !== lastValue) {
          lastValue = input.value;
          runValidation();
        }
      }, 150);
    });

    input.addEventListener("blur", function () {
      if (pollId) {
        clearInterval(pollId);
        pollId = null;
      }
      runValidation();
    });
  }

  attachIOSDateValidation(datePicker, handleDateSelection);
  attachIOSDateValidation(arrivalDatePicker, validateArrivalDate);
  attachIOSDateValidation(departureDatePicker, validateDepartureDate);

  // Show hide locations
  var radioButtons = document.querySelectorAll(
    '.delivery-location-input-container input[type="radio"]'
  );

  // Function to show the corresponding div based on the selected radio
  function showSelectedDiv(selectedElementId) {
    var allDivs = document.querySelectorAll(".delivery-location-container");

    allDivs.forEach(function (div) {
      if (div.id === selectedElementId) {
        div.style.display = "block";
      } else {
        div.style.display = "none";
      }
    });
  }

  // Initial setup based on checked radio
  radioButtons.forEach(function (radioButton) {
    if (radioButton.checked) {
      var selectedElementId = radioButton.getAttribute("data-open-element");
      showSelectedDiv(selectedElementId);
    }

    radioButton.addEventListener("change", function () {
      if (this.checked) {
        var selectedElementId = this.getAttribute("data-open-element");
        showSelectedDiv(selectedElementId);
      }
    });
  });

  // Show hide locations
  function isValidEmail(email) {
    // Regular expression pattern for a valid email address
    var pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return pattern.test(email);
  }
  function isValidUSPhoneNumber(input) {
    // Define the regex pattern for a US mobile number
    var pattern = /^(?:\+\d{1,3})?[-.\s]?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/;

    // Use the regex test() method to check if the input matches the pattern
    return pattern.test(input);
  }
  // Function to check if required fields are filled
  function checkInputs(value, address, addressValue) {
    const areRequiredFieldsFilled =
      Name.value !== "" &&
      recipientsContactNumber.value != "" &&
      Pname.value !== "" &&
      Email.value !== "" &&
      Lname.value !== "" &&
      Message.value !== "" &&
      (DeliveryDate.value !== "") & (value != "");
    if (
      typeof disabledDates !== "undefined" &&
      disabledDates.includes(document.getElementById("delivery_date").value)
    ) {
      showDateError("This date is disabled. Please choose another date.");
      datePicker.value = "";
      checkoutButton.disabled = false;
    } else {
      if (!areRequiredFieldsFilled) {
        checkoutButton.removeAttribute("disabled");
        document.getElementById("main-cart-attribute").style.pointerEvents =
          "all";
        errorContainer.innerHTML = "Please Fill all Required Fields.";
      } else {
        if (
          isValidEmail(Email.value) &&
          isValidUSPhoneNumber(recipientsContactNumber.value)
        ) {
          let notesContent = `Name::${Name.value} ${Lname.value}|Primary name on reservation::${Pname.value} |Email::${Email.value}|Message::${Message.value}|Delivery Date::${DeliveryDate.value}|Delivery Location::${value}`;
          const arrivalDate = document.getElementById("arrival-date");
          const depatureDate = document.getElementById("departure-date");
          const resortConfirmationNumber = document.getElementById(
            "resort-confirmation-number"
          );

          if (arrivalDate.value != "") {
            notesContent += `|Arival Date::${arrivalDate.value}`;
          }
          if (depatureDate.value != "") {
            notesContent += `|Departure Date::${depatureDate.value}`;
          }
          if (resortConfirmationNumber.value != "") {
            notesContent += `|Resort Confirmation Number::${resortConfirmationNumber.value}`;
          }
          if (recipientsContactNumber.value != "") {
            notesContent += `|Recipients Contact Number::${recipientsContactNumber.value}`;
          }
          document.getElementById("Cart-note").value = notesContent;
          document.getElementById("selected-location").value =
            document.querySelector(
              'input[name="available_dilevry_locations"]:checked'
            ).value;

          errorContainer.innerHTML = " ";

          if (addressValue != "" && addressValue != null) {
            openPopup();
          }
        } else {
          checkoutButton.removeAttribute("disabled");
          errorContainer.innerHTML =
            "Please Enter a correct Email and phone number";
          document.getElementById("main-cart-attribute").style.pointerEvents =
            "all";
        }
      }
    }
  }

  function removeError() {
    errorContainer.innerHTML = "";
  }

  function runValidation() {
    let selectedDiv = document
      .querySelector('input[name="available_dilevry_locations"]:checked')
      .parentElement.nextElementSibling.querySelector("select");
    let selectedOption = selectedDiv.options[selectedDiv.selectedIndex];
    let address = selectedOption.getAttribute("data-address");
    let addressValue = selectedDiv.value;
    document.getElementById("delivery_location_attr").value = addressValue;

    checkInputs(
      document.getElementById("delivery_location_attr").value,
      address,
      addressValue
    );
  }

  // Attach the checkInputs function to the blur event of input fields
  Name.addEventListener("blur", removeError);
  Pname.addEventListener("blur", removeError);
  Message.addEventListener("blur", removeError);
  DeliveryDate.addEventListener("blur", removeError);

  /* ---------- Main product requirement ---------- */

  /*
   * Upsell items cannot be bought on their own: the cart must also hold at
   * least one main (non-upsell) product before checkout is allowed.
   */
  const mainProductNotice = document.getElementById(
    "upsell-main-product-notice"
  );

  function noMainProductMessage() {
    return (
      (mainProductNotice && mainProductNotice.dataset.message) ||
      "One or more items in your cart require a gift to accompany them. Please add a gift to your cart before checking out."
    );
  }

  /*
   * Reads how many main products are in the cart. The rule itself lives in
   * Liquid (snippets/upsell-cart-state.liquid) and is served through
   * templates/cart.upsellCheck.liquid, so the answer stays correct after AJAX
   * cart changes that never reload the page.
   *
   * Resolves to null when the lookup fails, so a network blip never blocks a
   * legitimate checkout.
   */
  function getMainProductCount() {
    return fetch("/cart?view=upsellCheck")
      .then((response) => response.text())
      .then((responseText) => {
        // The view prints "<main product count>|<total line count>".
        const count = Number(responseText.trim().split("|")[0]);
        return Number.isNaN(count) ? null : count;
      })
      .catch((error) => {
        console.error("Could not check the cart for a main product:", error);
        return null;
      });
  }

  function showMainProductNotice(shouldShow) {
    if (!mainProductNotice) return;

    if (shouldShow) {
      mainProductNotice.textContent = noMainProductMessage();

      const shopUrl = mainProductNotice.dataset.shopUrl;
      if (shopUrl) {
        const link = document.createElement("a");
        link.href = shopUrl;
        link.textContent =
          (mainProductNotice.dataset.shopLabel || "Shop gifts") + " \u2192";
        mainProductNotice.appendChild(document.createTextNode(" "));
        mainProductNotice.appendChild(link);
      }
    }

    mainProductNotice.classList.toggle("is-visible", shouldShow);
  }

  function releaseCheckoutButton() {
    checkoutButton.disabled = false;
    checkoutButton.removeAttribute("disabled");
    document.getElementById("main-cart-attribute").style.pointerEvents = "all";
  }

  function refreshMainProductNotice() {
    getMainProductCount().then(function (mainProductCount) {
      if (mainProductCount === null) return;
      showMainProductNotice(mainProductCount === 0);
    });
  }

  refreshMainProductNotice();

  // Removing a line item re-renders cart sections without reloading the page.
  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refreshMainProductNotice);
  }

  checkoutButton.addEventListener("click", function (event) {
    checkoutButton.setAttribute("disabled", "disabled");
    // changed from 'none' to 'all' due disabled form issue on cart page
    document.getElementById("main-cart-attribute").style.pointerEvents = "all";

    getMainProductCount().then(function (mainProductCount) {
      if (mainProductCount === 0) {
        showMainProductNotice(true);
        releaseCheckoutButton();
        if (mainProductNotice) {
          mainProductNotice.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
        return;
      }

      showMainProductNotice(false);
      runCheckoutDateChecks();
    });
  });

  function runCheckoutDateChecks() {
    fetch(`/cart?view=getCurrentEST`)
      .then((response) => response.text())
      .then((responseText) => {
        responseText = responseText.trim();

        let currentESTDate = responseText.split(" ")[0].split("-");
        if (isBeforeCutOffTime(responseText)) {
          runValidation();
        } else {

          let [year, month, day] = currentESTDate;
          day = Number(day);

          let dayOfWeek = new Date(year, month - 1, day).getDay();
          let isWeekend = dayOfWeek === 6 || dayOfWeek === 0;

          if (
            enableCustomizeProductAdditionalDays &&
            personalizationItemExist !== undefined &&
            personalizationItemExist !== null &&
            personalizationItemExist !== "false"
          ) {
            day += customizeProductAdditionalDayWeekendsOnly && isWeekend
              ? dayOfWeek === 6 ? 2 : 1
              : customizeProductAdditionalDay;

            day = ("0" + day).slice(-2);
          }
          minDate = year + "-" + month + "-" + day;
          let minDeliveryDate = window.minDeliveryDate.split("-");
          let = minyear = minDeliveryDate[0];
          let minmonth = ("0" + Number(minDeliveryDate[1])).slice(-2);
          let minday = ("0" + Number(minDeliveryDate[2])).slice(-2);
          if (Number(minyear) > Number(year)) {
            minDate = minyear + "-" + minmonth + "-" + minday;
          } else if (
            Number(minyear) == Number(year) &&
            Number(month) < Number(minmonth)
          ) {
            minDate = minyear + "-" + minmonth + "-" + minday;
          } else if (
            Number(minyear) == Number(year) &&
            Number(month) == Number(minmonth) &&
            Number(minday) > Number(day)
          ) {
            minDate = minyear + "-" + minmonth + "-" + minday;
          } else {
            // do nothing here
          }
          window.minDeliveryDate = minDate;
          if (document.getElementById("delivery_date").value == "") {
            runValidation();
          } else {
            let currentSelectedDate = document
              .getElementById("delivery_date")
              .value.split("-");
            if (Number(currentSelectedDate[0]) > Number(year)) {
              runValidation();
            } else if (Number(currentSelectedDate[1]) > Number(month)) {
              runValidation();
            } else if (Number(currentSelectedDate[2]) >= Number(day)) {
              runValidation();
            } else {
              checkoutButton.disabled = false;
              document.getElementById(
                "main-cart-attribute"
              ).style.pointerEvents = "all";

              showDateError("You need to update the selected date to the next day.");
            }
          }
        }
      });
  }
});

function openPopup() {
  document.querySelector("upsell-popup").openPopup();
}

